import React, { useEffect, useRef } from "react";
import { Controller } from "react-hook-form";
import { Grid, Typography } from "@mui/material";
import ReactQuill, { ReactQuillProps } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { IFormField } from "../../../models/app";

interface Props extends IFormField {
  errors: any;
  control: any;
  required?: boolean;
  defaultValue?: any;
  setValue?: any;
  errorMessage?: string;
  watch?: any;
}

const RHEditor: React.FC<Props> = ({
  label,
  name,
  control,
  errors,
  required,
  defaultValue = "",
  setValue,
  hidden,
  onChange,
  isHorizontal,
  errorMessage,
  internalLabel = false,
}) => {
  const quillRef = useRef<ReactQuill | null>(null);

  useEffect(() => {
    const editor = quillRef.current?.getEditor();
    const editorElem = editor?.root;
    if (editorElem) {
      editorElem.style.fontSize = "1.25rem";
      editorElem.style.lineHeight = "1.6";
      editorElem.style.minHeight = "200px";
    }
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <Grid container alignItems="start" spacing={1} hidden={hidden} width="100%">

          <Grid item xs={12} md={label ? (!isHorizontal ? 12 : 2) : 12}>
            {label && (
              <Typography
                variant="body2"
                fontWeight={400}
                textAlign="start"
                minWidth="16ch"
              >
                {label}
                {required && <span style={{ color: "red" }}> *</span>}
              </Typography>
            )}
          </Grid>


          <Grid item xs={12} md={label ? (!isHorizontal ? 12 : 10) : 12}>
            <div
              style={{
                border: errors[name] || errorMessage ? "1px solid red" : "1px solid #ccc",
                borderRadius: 8,
                backgroundColor: "#fff",
              }}
            >
              <ReactQuill
                ref={quillRef}
                theme="snow"
                value={field.value || ""}
                onChange={(content) => {
                  onChange && onChange(content);
                  if (setValue) {
                    setValue(name, content);
                  }
                }}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, false] }],
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link"],
                    ["clean"],
                  ],
                }}
                formats={[
                  "header",
                  "bold",
                  "italic",
                  "underline",
                  "list",
                  "bullet",
                  "link",
                ]}
              />
            </div>
            {errors[name] && (
              <Typography
                variant="caption"
                color="error.main"
                textAlign="start"
              >
                {errors[name].message}
              </Typography>
            )}
            {errorMessage && (
              <Typography
                variant="caption"
                color="error.main"
                textAlign="start"
              >
                {errorMessage}
              </Typography>
            )}
          </Grid>
        </Grid>
      )}
    />
  );
};

export default RHEditor;
